import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public date: Date = new Date();

}



// WEBPACK FOOTER //
// /dist/src/app/ui/footer/footer.component.ts